import React from 'react'
import Slides from '../slides/Slides'
import { Link } from 'react-router-dom';
import Footer from '../footer/Footer';

const Institucional = ({M}) => {
   return (
      <>
         <Slides M={M} tipoSlides={"institucional"} />
         <div className="section animated fadeIn">
            <div className="row center">
               <div className="col s12 m12 l12 x12">
                  <Link to={""} className="btn btn-large waves-effect waves-light bg-latitud pulse" type="submit">Descargá Nuestra Presentación
                     (PDF)
                     <i className="material-icons right">cloud_download</i>
                  </Link>
               </div>
            </div>
         </div>
         <div className="section animated fadeIn">
            <div className="row center">
               <h4 className="light-blue-text text-accent-3">MISIÓN</h4>
               <div className="container font-size-18 justify grey-text text-darken-1">
                     <blockquote>
                        <p>
                           <strong>
                              <em>
                                 La misión de nuestra aseguradora es la de generar relaciones con nuestros clientes a largo plazo, 
                                 <br/>
                                 brindándoles el respaldo de una compañía con experiencia, un contacto directo con los responsables, 
                                 <br/>
                                 todo ello, dentro de la normativa vigente y valores éticos.
                              </em>
                        </strong>
                        </p>
                     </blockquote>
               </div>
            </div>      
         </div>
         <div className="section grey lighten-2 animated fadeIn">
            <div className="row center">
               <h4 className="light-blue-text text-accent-3">VISIÓN</h4>
               <div className="container font-size-18 justify grey-text text-darken-1">
                  <blockquote>
                     <p><strong><em>Ser la aseguradora de empresas número uno de la región cumpliendo los más altos estándares de calidad y contando con un equipo humano de excelencia.</em></strong></p>
                  </blockquote>
               </div>
            </div>      
         </div>
         <div className="section animated fadeIn">
            <div className="row center">
               <h4 className="light-blue-text text-accent-3">PRINCIPIOS</h4>
            </div> 
            <div className="section container row justify font-size-18 grey-text text-darken-1">
               <div className="col s12 m6 push-m1">    
                  <ul className="">
                     <li className="collection-item"><strong><em>Transparencia</em></strong></li>
                     <li className="collection-item"><strong><em>Concientización</em></strong></li>
                     <li className="collection-item"><strong><em>Centralización</em></strong></li>
                     <li className="collection-item"><strong><em>Innovación</em></strong></li>
                  </ul>
               </div>
               <div className="col s12 m6 push-m2">   
                  <ul className="">
                     <li className="collection-item"><strong><em>Eficiencia organizacional</em></strong></li>
                     <li className="collection-item"><strong><em>Calidad de Procesos</em></strong></li>
                     <li className="collection-item"><strong><em>Equipo de Excelencia</em></strong></li>
                     <li className="collection-item"><strong><em>Satisfacción del cliente</em></strong></li>
                  </ul>
               </div>                        
            </div>
         </div>
         <div className="section grey lighten-2 animated fadeIn">
            <div className="row center">
               <h4 className="light-blue-text text-accent-3">AUTORIDADES</h4>
            </div>
            <div className="row">
               <div className="col s12 m5 offset-m4">    
                  <ul className="font-size-18 grey-text text-darken-1">
                     <li class="collection-item"><em><strong>Presidente:</strong> Lic. Cristian José Luis Zampini</em></li>
                     <li class="collection-item"><em><strong>Vicepresidente:</strong> Sr. Juan Gabriel Valero Zazzarini</em></li>
                     <li class="collection-item"><em><strong>Director Titular:</strong>  Sr. Nelson Federico Bartoletti</em></li>
                     <li class="collection-item"><em><strong>Director Titular:</strong> Ing. Pablo Marcelo Jenefes Quevedo</em></li>
                     <li class="collection-item"><em><strong>Director Titular:</strong> Sr. Federico Olver Yáñez</em></li>
                     <li class="collection-item"><em><strong>Director Titular:</strong> Sr. Marcelo Guillermo Casasco</em></li>
                     <li class="collection-item"><em><strong>Director Titular:</strong> Sr. Nelson Policarpo Llanos</em></li>
                     <li class="collection-item"><em><strong>Director Titular:</strong> Sra. Andrea Marcela Vedia</em></li>

                     <li class="collection-item"><em><strong>Director Independiente:</strong> CPN. Omar Kamal Musri</em></li>

                     <li class="collection-item"><em><strong>Director Suplente:</strong> Sr. Juan Mateo Aguiar</em></li>
                     <li class="collection-item"><em><strong>Director Suplente:</strong> Sr. Jose Luis Cianchino</em></li>

                     <li class="collection-item"><em><strong>Síndico Titular:</strong> Dr. Horacio Antonio Macedo</em></li>
                     <li class="collection-item"><em><strong>Síndico Titular:</strong>  CPN Normando Darío Siles</em></li>
                     <li class="collection-item"><em><strong>Síndico Titular:</strong> Dr. Fernando Jose Yécora</em></li>
                     <li class="collection-item"><em><strong>Síndico Suplente:</strong> Dr. Juan Sebastian Jenefes Quevedo</em></li>
                     <li class="collection-item"><em><strong>Síndico Suplente:</strong> CPN Nanci Isabel Berardi</em></li>
                     <li class="collection-item"><em><strong>Síndico Suplente:</strong> Dr. Ítalo Gerardo Pascuttini</em></li>
                     <li class="collection-item"><em><strong>Gerente General:</strong> CPN Carlos Alberto Enrique Barni</em></li> 
                  </ul>
               </div>
            </div> 
         </div>
         <div className="section animated fadeIn">
            <div className="row center">
               <h4 className="light-blue-text text-accent-3">HISTORIA</h4>
               <div className="container justify font-size-18 grey-text text-darken-1">
                  <blockquote>
                     <p><strong><em>La Compañía Argentina de Seguros Latitud Sur S.A., se constituyó el día 14 de febrero de 1969, con capitales vinculados al sector asegurador nacional, aprobada por la Superintendencia de Seguros de la Nación para la producción de seguros en todo el país y con autorización para operar en la mayoría de los Ramos Patrimoniales y de Vida.</em></strong></p>
                  </blockquote>
                  <blockquote>
                     <p><strong><em>Hacia el año 1980, el sector tabacalero de la provincia de Jujuy decidió la compra de una Aseguradora que estuviera en operaciones (en aquella época estaba prohibida la instalación de nuevas aseguradoras), con los riesgos que esto implica (pasivos ocultos). La Compañía elegida fue la Compañía Argentina de Seguros LATITUD SUR S.A., cuyo paquete accionario fue adquirido a finales del año 1982. Y todo el proceso de saneamiento de la Compañía adquirida, le llevó al sector tabacalero jujeño más de quince años, culminando éste aproximadamente en el año 2000.</em></strong></p>
                  </blockquote>
                  <blockquote>
                     <p><strong><em>En un primer momento, la compra fue realizada por la Cámara del Tabaco de Jujuy, en conjunto con la Cooperativa de Tabacaleros de Jujuy Ltda. Actualmente la Cámara del Tabaco de Jujuy es el accionista principal, con un 99,9% del Capital Social. Desde 1.989, se trasladó la Casa Central a Jujuy, se cerraron todas las operaciones alejadas y se concentraron todas las operaciones de la Compañía en nuestra provincia, y en un principio, exclusivamente en los riesgos vinculados con el sector tabacalero.</em></strong></p>
                  </blockquote>
                  <blockquote>
                     <p><strong><em>A comienzo del año 2000 se inició una nueva etapa, empezando a ofrecer nuestros servicios fuera del sector tabacalero jujeño. El proceso de crecimiento fue lento pero continuo, protegiendo el capital de nuestros accionistas y siendo muy cautelosos en la asunción de riesgos. Hoy somos la Aseguradora de Riesgos del Trabajo N° 1 de la Provincia de Jujuy y la N° 3 de la Provincia de Salta en cuanto al total de trabajadores asegurados.</em></strong></p>
                  </blockquote>    
               </div>
            </div>      
         </div>
      </>
   );
}

export default Institucional